import React, { useState } from 'react';
import { CHECKOUT } from '../data/links';
import { record } from './Gate';
import { SectionHeading } from './SectionHeading';
import { LockChip } from './LockChip';
interface CommunityCardProps {
  memberEmail: string;
}
export function CommunityCard({
  memberEmail
}: CommunityCardProps) {
  const [joined, setJoined] = useState(false);
  const join = () => {
    record(memberEmail, 'community-waitlist');
    setJoined(true);
  };
  return <section aria-labelledby="community-heading" id="community" className="scroll-mt-24" data-id="element-126" data-mp="3m89mgs8l96lf">
      <SectionHeading index="08" title="The Inventor's Club" locked note="A new build brief every month, with a place to post what your child actually made, collapses included." data-id="element-127" data-mp="3r2dwxlh2bwr9">
        <LockChip label="Not open yet" data-id="element-128" data-mp="3h8x008lmq1jd" />
      </SectionHeading>

      <article className="mt-8 bg-surface p-6 sm:p-10" data-id="element-129" data-mp="33c0coh4pz278">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-130" data-mp="38abjeizpwwl8">
          <div data-id="element-131" data-mp="t878tdtiwsar">
            <h3 className="font-display font-semibold text-[26px] leading-tight text-locked sm:text-[32px]" data-id="element-132" data-mp="t7o2yvh5dud3">
              Opening soon
            </h3>
            <p className="mt-3 max-w-[42rem] font-sans text-[16px] leading-relaxed text-locked" data-id="element-133" data-mp="obgt4rlmrypv">
              One brief a month, written the way the twelve books are: a real constraint, a way to
              measure whether it worked, and the failures to expect. Places will be limited so the
              board stays worth reading.
            </p>
          </div>

          <div className="shrink-0 lg:w-[19rem] lg:border-l lg:border-rule lg:pl-10" data-id="element-134" data-mp="5k64kh3dny15">
            {joined ? <div role="status" data-id="element-135" data-mp="jbuk6ucu54mv">
                <p className="font-sans text-[16px] leading-relaxed text-ink" data-id="element-136" data-mp="ejjj3o6czcsq">You are on the list.</p>
                <p className="mt-1 font-sans text-[12px] leading-relaxed text-locked" data-id="element-137" data-mp="3mzcx9wd7wc6m">
                  We will write to {memberEmail || 'your member address'} before places are offered.
                </p>
              </div> : <>
                {CHECKOUT.community ? <a href={CHECKOUT.community} onClick={() => record(memberEmail, 'community-click')} className="block w-full border border-locked px-5 py-3 text-center font-sans text-[13px] leading-none text-locked transition-colors duration-150 ease-out hover:border-ink hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-138" data-mp="1qvyi6zsjc0u2">
                    Take a place
                  </a> : <button type="button" onClick={join} className="w-full border border-locked px-5 py-3 font-sans text-[13px] leading-none text-locked transition-colors duration-150 ease-out hover:border-ink hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-139" data-mp="1cytcx20nb5zv">
                    Join the waitlist
                  </button>}
                <p className="mt-3 font-sans text-[12px] leading-relaxed text-locked" data-id="element-140" data-mp="7xacm4zn9eay">
                  Uses the email you signed in with. Nothing else.
                </p>
              </>}
          </div>
        </div>
      </article>
    </section>;
}